import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IncometaxService } from '../../Model/Incometax/incometax.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertSuccessComponent } from '../Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Alert/alert-warning/alert-warning.component';
import { LoginService } from '../../Model/Login/login.service';
import { LoaderComponent } from '../Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { FormsModule } from '@angular/forms';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';

@Component({
  selector: 'app-mail-approval',
  standalone: true,
  imports: [CommonModule, LoaderComponent, FormsModule],
  templateUrl: './mail-approval.component.html',
  styleUrl: './mail-approval.component.scss'
})
export class MailApprovalComponent {
  Key = null as any;
  domain = null as any;
  status = null as any;
  isDisabled = false;
  remark = null;

  LogoPath = null;
  aurl = null as any;
  IsAllow = false;
  Message = null;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private musterAttendance: MusterAttendanceService,
    private login: LoginService,
    protected common: CommonService,
    private toast: ToastService,
  ) { }

  ngOnInit(): void {
    this.Key = this.route.snapshot.queryParamMap.get('key');
    this.domain = this.route.snapshot.queryParamMap.get('domain');
    this.status = this.route.snapshot.queryParamMap.get('status');
    if (this.domain != null && this.domain != '' && this.domain != undefined && this.Key != null && this.Key != '' && this.Key != undefined) {
      window.onload = async () => {
        this.GetCredentials();
      };
    } else {
      setTimeout(() => {
        this.closeTab();
      }, 2000);
    }
  }

  Validate(form: any) {
    if (form.valid) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + (this.common.ToLowerCase(this.status) == 'approved' ? 'Approve' : 'Reject') + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.ESS_SiteWiseAttendanceSendToPOCOASApproval();
        }
      });

    } else {
      this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      form.submitted = true;
    }
  }

  async ESS_SiteWiseAttendanceSendToPOCOASApproval(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_SiteWiseAttendanceSendToPOCOASApproval({ 'encryptedValue': this.Key, 'remark': this.remark }, this.aurl).subscribe({
        next: async (response) => {
          this.isDisabled = false;
          if (response.Error_Code == '01') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              this.closeTab();
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              this.closeTab();
            });
          }

          resolve(true);
        },
        complete: () => { },
        error: (error) => {
        },
      });
    });
  }

  async ESS_GetPOCMailStatusOAS(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_GetPOCMailStatusOAS({ 'key': this.Key }, this.aurl).subscribe({
        next: async (response) => {
          this.isDisabled = false;
          if(response.ReturnOutput == '' || response.ReturnOutput == null){
            this.IsAllow = true;
          }else{
            this.Message = response.ReturnOutput;
          }
          resolve(true);
        },
        complete: () => { },
        error: (error) => {
        },
      });
    });
  }


  GetCredentials() {
    this.login.GetCredentials({ Domain: this.domain, }).subscribe({
      next: (response) => {
        if (response.Domain_Check != undefined && response.Domain_Check.length > 0) {
          this.LogoPath = response.Domain_Check[0].CompanyLogoPath;
          this.aurl = response.Domain_Check[0].ApiUrl;
          this.ESS_GetPOCMailStatusOAS();
          // const modalRef = this.modalService.open(ApproveRejectDialogComponent, {
          //   backdrop: 'static',
          // });
          // modalRef.componentInstance.showReInitiat = false;
          // modalRef.componentInstance.showReject = this.common.ToLowerCase(this.status) == 'rejected';
          // modalRef.componentInstance.showApprove = this.common.ToLowerCase(this.status) == 'approved';
          // modalRef.result.then(result => {
          //   if (result != undefined) {
          //     this.remark = result.Remark;
          //     this.ESS_SiteWiseAttendanceSendToPOCOASApproval(response.Domain_Check[0].ApiUrl)
          //   } else {
          //     this.closeTab();
          //   }
          // });
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  closeTab(): void {
    window.open('', '_self');
    window.close();

    setTimeout(() => {
      const message = `
      <div style="text-align: center; margin-top: 100px;">
        <h2>Process Completed</h2>
        <p>You may now close this tab manually.</p>
        <button onclick="window.close()">Close Tab</button>
      </div>
    `;
      document.body.innerHTML = message;
    }, 100);
  }
}
